import React from 'react';
import cx from 'classnames';
import { Section, Container } from 'components/shared';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { isValidTitle } from 'utils/validateTitle';

import loadable from '@loadable/component';
const Contact = loadable(() =>
  import('components/components/molecules/Contact'),
);

const SupportContacts = ({ fields, rendering }) => {
  const title = getFieldValue(fields, 'title');
  const textStyle = getFieldValue(fields, 'textStyle') || 'blue-white';
  const textAlignment = getFieldValue(fields, 'textAlignment') || 'left';
  const customCares = getFieldValue(fields, 'customCares');

  const sortedContacts = customCares
    .filter((c) => c.name)
    .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));

  return (
    <Section
      id={'contactus'}
      className={cx({
        'bg-light-blue': textStyle === 'blue-gray' || textStyle === 'blue-blue',
        'bg-mattamy-blue': textStyle === 'white-blue',
        'bg-white': textStyle === 'blue-white',
      })}
    >
      <Container id={'afterhours-contact'} className='w-full'>
        <div
          className={cx('flex', {
            'justify-start': textAlignment === 'left',
            'justify-center text-center': textAlignment === 'center',
          })}
        >
          {isValidTitle(title) && (
            <h3
              className={cx(
                'text-3xl md:text-4xl font-trade-gothic-20 md:w-6/12 leading-6 md:leading-10 mt-10 mb-12',
                {
                  'text-mattamy-blue':
                    textStyle === 'blue-gray' ||
                    textStyle === 'blue-white' ||
                    textStyle === 'blue-blue',
                  'text-white': textStyle === 'white-blue',
                },
              )}
            >
              {title}
            </h3>
          )}
        </div>
        <div className='flex flex-col md:grid grid-cols-3 mb-4'>
          {sortedContacts.map((contact) => (
            <div className='mb-8 md:mb-8 md:pr-20' key={contact.name}>
              <Contact
                white={textStyle === 'white-blue'}
                title={contact.name}
                email={contact.email}
                phoneNumberCall={contact.phoneNumberCall}
                phoneNumberMessage={contact.phoneNumberMessage}
              />
            </div>
          ))}
        </div>
      </Container>
    </Section>
  );
};

export default SupportContacts;
